import { defineMessages } from 'react-intl';

export default defineMessages({
  footerPublicCopyright: {
    defaultMessage: '© 2016-{yearTo} 2N Telekomunikace a.s. All rights reserved.',
    id: 'footerPublic.copyright',
  },
  marketingMessageButtonLabel: {
    defaultMessage: 'Interested in knowing more?',
    id: 'marketingMessage.buttonLabel',
  },
  marketingMessageSubtitle: {
    defaultMessage: 'The most effective way to defend against cyber attacks - Now available for My2N',
    id: 'marketingMessage.subtitle',
  },
  marketingMessageTitle: {
    defaultMessage: 'Enhanced Security with Multi-Factor Authentication',
    id: 'marketingMessage.title',
  },
});
